import { render } from "./TopicDialog.vue?vue&type=template&id=64d180ac&scoped=true"
import script from "./TopicDialog.vue?vue&type=script&lang=js"
export * from "./TopicDialog.vue?vue&type=script&lang=js"

import "./TopicDialog.vue?vue&type=style&index=0&id=64d180ac&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d180ac"]])

export default __exports__